import { defineStore } from 'pinia'

// Theme persistence. Element Plus toggles its dark theme via a single
// `dark` class on <html>; Monaco already defaults to vs-dark so the two
// layers stay in sync without us touching the editor.

export type Theme = 'light' | 'dark'

const THEME_KEY = 'nginx-ui.theme'

function systemPrefersDark(): boolean {
  return typeof window !== 'undefined'
    && window.matchMedia
    && window.matchMedia('(prefers-color-scheme: dark)').matches
}

function applyTheme(t: Theme) {
  if (typeof document === 'undefined') return
  document.documentElement.classList.toggle('dark', t === 'dark')
}

export const useSettings = defineStore('settings', {
  state: () => ({
    theme: 'light' as Theme,
  }),
  actions: {
    hydrate() {
      const stored = (typeof localStorage !== 'undefined' ? localStorage.getItem(THEME_KEY) : null) as Theme | null
      this.theme = stored ?? (systemPrefersDark() ? 'dark' : 'light')
      applyTheme(this.theme)
    },
    setTheme(t: Theme) {
      this.theme = t
      if (typeof localStorage !== 'undefined') localStorage.setItem(THEME_KEY, t)
      applyTheme(t)
    },
    toggleTheme() {
      this.setTheme(this.theme === 'dark' ? 'light' : 'dark')
    },
  },
})
